<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="letterTemplate.info.title"></h4>
  </div>
  <div class="modal-body">
    <p class="has-text-grey mb-4" translate="letterTemplate.info.subtitle"></p>

    <app-please-be-patient></app-please-be-patient>

    <div [formGroup]="form" novalidate>
      <fino-input
        class="field"
        formControlName="department"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>
      <fino-input
        class="field"
        formControlName="faxNumber"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>
      <fino-input
        class="field"
        formControlName="phoneNumber"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>
      <!-- May come from Intba or is Custom set by form -->

      <fino-input
        formControlName="displayName"
        class="field"
        [disabled]="!form.controls.displayNameCustomEnabled.value"
        inputAutocompleteOff
        validationIndicator
      >
        <div
          class="is-fullheight is-flex is-justify-content-center is-align-items-center ml-4"
          input-right
        >
          <fino-switch
            formControlName="displayNameCustomEnabled"
            [hideLabel]="true"
          ></fino-switch>
        </div>
      </fino-input>
      <div
        class="is-flex is-justify-content-space-between is-align-items-center mb-4"
      >
        <h5
          class="ml-1 title mb-0 is-5"
          translate="letterTemplate.info.senderAddress"
        ></h5>
        <fino-switch
          formControlName="customAddressEnabled"
          [hideLabel]="true"
        ></fino-switch>
      </div>
      <fino-input
        formControlName="address"
        class="field"
        [disabled]="!form.controls.customAddressEnabled.value"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>
      <fino-input
        formControlName="postcode"
        class="field"
        [disabled]="!form.controls.customAddressEnabled.value"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>
      <fino-input
        formControlName="city"
        class="field"
        [disabled]="!form.controls.customAddressEnabled.value"
        inputAutocompleteOff
        validationIndicator
      ></fino-input>
    </div>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-4">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        [disabled]="form.invalid"
        (click)="submit()"
        fino-button
        label="letterTemplate.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="letterTemplate.abort"
      ></button>
    </div>
  </div>
</div>
